import React from "react";
import "./popularSearches.css";
import RoundedLinkButton from "../../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";

export default function PopularSearches() {
  const popularSearches = [
    {
      label: "Behandlingrum Stockholm",
      municipality: "stockholm",
      roomtype: "behandlingsrum",
    },
    {
      label: "Idrott/danslokal Malmö",
      municipality: "malmö",
      roomtype: "idrott/danslokal",
    },
    {
      label: "Kontorslokal Göteborg",
      municipality: "göteborg",
      roomtype: "kontorslokal",
    },
    // {
    //   label: "Ateljé Göteborg",
    //   municipality: "göteborg",
    //   roomtype: "eventlokal",
    // },
  ];
  const buildSearchUrl = (municipality, roomtype) => {
    return `/lediga-lokaler/${municipality.toLowerCase()}/${roomtype.toLowerCase().replace(/\//g, "&").replace(/&/g, "%26")}`;
  };
  return (
    <div className="popular-searches">
      <p>Populära sökningar: </p>
      <div className="popular-searches-btns">
        {popularSearches.map((search, index) => (
          <RoundedLinkButton
            key={index}
            label={search.label}
            color={"white"}
            size={"sm"}
            href={buildSearchUrl(search.municipality, search.roomtype)}
          />
        ))}
      </div>
    </div>
  );
}
